import classNames from 'classnames';
import { omit } from 'lodash-es';
import type { PropsWithChildren } from 'react';

export type TextProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>;

export const Text = (props: PropsWithChildren<TextProps>) => (
  <p {...omit(props, 'className')} className={classNames('', props.className)}>{props.children}</p>
);


export default Text;
